import angular from 'angular';
import { Breadcrumbs, Breadcrumb } from '../../breadcrumbs';
import { STATES } from '../../../../constants';
import { selectors, actions } from '../../../../state';
import React from 'react';
import { render } from 'react-dom';
import { startCase } from 'lodash-es';

// Module definition
// ------------------------------------------------
let mod = angular.module('app.breadcrumb', []);

export default mod;

const getBreadcrumbName = state => {
  let title = state && state.title;

  if (typeof title === 'function') {
    title = title();
  }

  return title;
};

function mountBreadcrumbs(mountPoint, { goToDashboard, breadcrumbText }) {
  if (!mountPoint) return;
  render(
    <>
      {breadcrumbText ? (
        <Breadcrumbs onHome={goToDashboard}>
          <Breadcrumb> {breadcrumbText} </Breadcrumb>
        </Breadcrumbs>
      ) : (
        ''
      )}
    </>,
    mountPoint
  );
}

mod.component('breadcrumb', {
  controller: class BreadcrumbController {
    constructor(updStore, $state, $element) {
      Object.assign(this, {
        updStore,
        $state,
        $element,
      });
    }

    $postLink() {
      this.mountPoint = this.$element[0];
    }

    goToDashboard() {
      this.updStore.dispatch(actions.router.stateGo(STATES.DASHBOARD));
    }

    $onInit() {
      this.updStore.subscribe(() => {
        const state = this.updStore.getState();
        const name = selectors.router.currentName(state);
        const [app, stateType, parent] = name.split('.');
        let parentState = this.$state.get(`${app}.${stateType}.${parent}`);

        // Verify can be directly routed to outside of a parent state so we need
        // to display the right breadcrumb in that case
        if ((stateType === 'verify' && !parent) || stateType === 'account') {
          parentState = this.$state.get(`${app}.${stateType}`);
        }
        const breadcrumbText = getBreadcrumbName(parentState);
        mountBreadcrumbs(this.mountPoint, {
          breadcrumbText,
          goToDashboard: () => this.goToDashboard(),
        });
      });
    }
  },
});
